// 시군구 표준목록 (행정안전부 법정동코드 전체자료 기반, 폐지 제외)
// code = 법정동 시군구 5자리 = 현장 admCd 앞5와 동일 체계 → 시공반장 활동지역 매칭 키
// 구-보유 시(수원·성남·용인 등)는 실제 동이 존재하는 구 단위만 포함(상위 시 제외)
// 생성: V2/법정동코드 전체자료.txt → 추출. 행정구역 개편 시에만 갱신.

export interface SigunguOption {
  /** 법정동 시군구 5자리 */
  code: string;
  /** 전체명 (예: 서울특별시 종로구) */
  name: string;
  /** 시·도 (예: 서울특별시) */
  sido: string;
  /** 시군구 (예: 종로구 / 수원시 장안구) */
  sigungu: string;
}

const SIGUNGU_BASE: SigunguOption[] = [
  { code: "11110", name: "서울특별시 종로구", sido: "서울특별시", sigungu: "종로구" },
  { code: "11140", name: "서울특별시 중구", sido: "서울특별시", sigungu: "중구" },
  { code: "11170", name: "서울특별시 용산구", sido: "서울특별시", sigungu: "용산구" },
  { code: "11200", name: "서울특별시 성동구", sido: "서울특별시", sigungu: "성동구" },
  { code: "11215", name: "서울특별시 광진구", sido: "서울특별시", sigungu: "광진구" },
  { code: "11230", name: "서울특별시 동대문구", sido: "서울특별시", sigungu: "동대문구" },
  { code: "11260", name: "서울특별시 중랑구", sido: "서울특별시", sigungu: "중랑구" },
  { code: "11290", name: "서울특별시 성북구", sido: "서울특별시", sigungu: "성북구" },
  { code: "11305", name: "서울특별시 강북구", sido: "서울특별시", sigungu: "강북구" },
  { code: "11320", name: "서울특별시 도봉구", sido: "서울특별시", sigungu: "도봉구" },
  { code: "11350", name: "서울특별시 노원구", sido: "서울특별시", sigungu: "노원구" },
  { code: "11380", name: "서울특별시 은평구", sido: "서울특별시", sigungu: "은평구" },
  { code: "11410", name: "서울특별시 서대문구", sido: "서울특별시", sigungu: "서대문구" },
  { code: "11440", name: "서울특별시 마포구", sido: "서울특별시", sigungu: "마포구" },
  { code: "11470", name: "서울특별시 양천구", sido: "서울특별시", sigungu: "양천구" },
  { code: "11500", name: "서울특별시 강서구", sido: "서울특별시", sigungu: "강서구" },
  { code: "11530", name: "서울특별시 구로구", sido: "서울특별시", sigungu: "구로구" },
  { code: "11545", name: "서울특별시 금천구", sido: "서울특별시", sigungu: "금천구" },
  { code: "11560", name: "서울특별시 영등포구", sido: "서울특별시", sigungu: "영등포구" },
  { code: "11590", name: "서울특별시 동작구", sido: "서울특별시", sigungu: "동작구" },
  { code: "11620", name: "서울특별시 관악구", sido: "서울특별시", sigungu: "관악구" },
  { code: "11650", name: "서울특별시 서초구", sido: "서울특별시", sigungu: "서초구" },
  { code: "11680", name: "서울특별시 강남구", sido: "서울특별시", sigungu: "강남구" },
  { code: "11710", name: "서울특별시 송파구", sido: "서울특별시", sigungu: "송파구" },
  { code: "11740", name: "서울특별시 강동구", sido: "서울특별시", sigungu: "강동구" },
  { code: "12110", name: "전남광주통합특별시 목포시", sido: "전남광주통합특별시", sigungu: "목포시" },
  { code: "12130", name: "전남광주통합특별시 여수시", sido: "전남광주통합특별시", sigungu: "여수시" },
  { code: "12150", name: "전남광주통합특별시 순천시", sido: "전남광주통합특별시", sigungu: "순천시" },
  { code: "12170", name: "전남광주통합특별시 나주시", sido: "전남광주통합특별시", sigungu: "나주시" },
  { code: "12190", name: "전남광주통합특별시 광양시", sido: "전남광주통합특별시", sigungu: "광양시" },
  { code: "12210", name: "전남광주통합특별시 동구", sido: "전남광주통합특별시", sigungu: "동구" },
  { code: "12240", name: "전남광주통합특별시 서구", sido: "전남광주통합특별시", sigungu: "서구" },
  { code: "12270", name: "전남광주통합특별시 남구", sido: "전남광주통합특별시", sigungu: "남구" },
  { code: "12300", name: "전남광주통합특별시 북구", sido: "전남광주통합특별시", sigungu: "북구" },
  { code: "12330", name: "전남광주통합특별시 광산구", sido: "전남광주통합특별시", sigungu: "광산구" },
  { code: "12710", name: "전남광주통합특별시 담양군", sido: "전남광주통합특별시", sigungu: "담양군" },
  { code: "12720", name: "전남광주통합특별시 곡성군", sido: "전남광주통합특별시", sigungu: "곡성군" },
  { code: "12730", name: "전남광주통합특별시 구례군", sido: "전남광주통합특별시", sigungu: "구례군" },
  { code: "12740", name: "전남광주통합특별시 고흥군", sido: "전남광주통합특별시", sigungu: "고흥군" },
  { code: "12750", name: "전남광주통합특별시 보성군", sido: "전남광주통합특별시", sigungu: "보성군" },
  { code: "12760", name: "전남광주통합특별시 화순군", sido: "전남광주통합특별시", sigungu: "화순군" },
  { code: "12770", name: "전남광주통합특별시 장흥군", sido: "전남광주통합특별시", sigungu: "장흥군" },
  { code: "12780", name: "전남광주통합특별시 강진군", sido: "전남광주통합특별시", sigungu: "강진군" },
  { code: "12790", name: "전남광주통합특별시 해남군", sido: "전남광주통합특별시", sigungu: "해남군" },
  { code: "12800", name: "전남광주통합특별시 영암군", sido: "전남광주통합특별시", sigungu: "영암군" },
  { code: "12810", name: "전남광주통합특별시 무안군", sido: "전남광주통합특별시", sigungu: "무안군" },
  { code: "12820", name: "전남광주통합특별시 함평군", sido: "전남광주통합특별시", sigungu: "함평군" },
  { code: "12830", name: "전남광주통합특별시 영광군", sido: "전남광주통합특별시", sigungu: "영광군" },
  { code: "12840", name: "전남광주통합특별시 장성군", sido: "전남광주통합특별시", sigungu: "장성군" },
  { code: "12850", name: "전남광주통합특별시 완도군", sido: "전남광주통합특별시", sigungu: "완도군" },
  { code: "12860", name: "전남광주통합특별시 진도군", sido: "전남광주통합특별시", sigungu: "진도군" },
  { code: "12870", name: "전남광주통합특별시 신안군", sido: "전남광주통합특별시", sigungu: "신안군" },
  { code: "26110", name: "부산광역시 중구", sido: "부산광역시", sigungu: "중구" },
  { code: "26140", name: "부산광역시 서구", sido: "부산광역시", sigungu: "서구" },
  { code: "26170", name: "부산광역시 동구", sido: "부산광역시", sigungu: "동구" },
  { code: "26200", name: "부산광역시 영도구", sido: "부산광역시", sigungu: "영도구" },
  { code: "26230", name: "부산광역시 부산진구", sido: "부산광역시", sigungu: "부산진구" },
  { code: "26260", name: "부산광역시 동래구", sido: "부산광역시", sigungu: "동래구" },
  { code: "26290", name: "부산광역시 남구", sido: "부산광역시", sigungu: "남구" },
  { code: "26320", name: "부산광역시 북구", sido: "부산광역시", sigungu: "북구" },
  { code: "26350", name: "부산광역시 해운대구", sido: "부산광역시", sigungu: "해운대구" },
  { code: "26380", name: "부산광역시 사하구", sido: "부산광역시", sigungu: "사하구" },
  { code: "26410", name: "부산광역시 금정구", sido: "부산광역시", sigungu: "금정구" },
  { code: "26440", name: "부산광역시 강서구", sido: "부산광역시", sigungu: "강서구" },
  { code: "26470", name: "부산광역시 연제구", sido: "부산광역시", sigungu: "연제구" },
  { code: "26500", name: "부산광역시 수영구", sido: "부산광역시", sigungu: "수영구" },
  { code: "26530", name: "부산광역시 사상구", sido: "부산광역시", sigungu: "사상구" },
  { code: "26710", name: "부산광역시 기장군", sido: "부산광역시", sigungu: "기장군" },
  { code: "27110", name: "대구광역시 중구", sido: "대구광역시", sigungu: "중구" },
  { code: "27140", name: "대구광역시 동구", sido: "대구광역시", sigungu: "동구" },
  { code: "27170", name: "대구광역시 서구", sido: "대구광역시", sigungu: "서구" },
  { code: "27200", name: "대구광역시 남구", sido: "대구광역시", sigungu: "남구" },
  { code: "27230", name: "대구광역시 북구", sido: "대구광역시", sigungu: "북구" },
  { code: "27260", name: "대구광역시 수성구", sido: "대구광역시", sigungu: "수성구" },
  { code: "27290", name: "대구광역시 달서구", sido: "대구광역시", sigungu: "달서구" },
  { code: "27710", name: "대구광역시 달성군", sido: "대구광역시", sigungu: "달성군" },
  { code: "27720", name: "대구광역시 군위군", sido: "대구광역시", sigungu: "군위군" },
  { code: "28125", name: "인천광역시 제물포구", sido: "인천광역시", sigungu: "제물포구" },
  { code: "28155", name: "인천광역시 영종구", sido: "인천광역시", sigungu: "영종구" },
  { code: "28177", name: "인천광역시 미추홀구", sido: "인천광역시", sigungu: "미추홀구" },
  { code: "28185", name: "인천광역시 연수구", sido: "인천광역시", sigungu: "연수구" },
  { code: "28200", name: "인천광역시 남동구", sido: "인천광역시", sigungu: "남동구" },
  { code: "28237", name: "인천광역시 부평구", sido: "인천광역시", sigungu: "부평구" },
  { code: "28245", name: "인천광역시 계양구", sido: "인천광역시", sigungu: "계양구" },
  { code: "28275", name: "인천광역시 서해구", sido: "인천광역시", sigungu: "서해구" },
  { code: "28290", name: "인천광역시 검단구", sido: "인천광역시", sigungu: "검단구" },
  { code: "28710", name: "인천광역시 강화군", sido: "인천광역시", sigungu: "강화군" },
  { code: "28720", name: "인천광역시 옹진군", sido: "인천광역시", sigungu: "옹진군" },
  { code: "30110", name: "대전광역시 동구", sido: "대전광역시", sigungu: "동구" },
  { code: "30140", name: "대전광역시 중구", sido: "대전광역시", sigungu: "중구" },
  { code: "30170", name: "대전광역시 서구", sido: "대전광역시", sigungu: "서구" },
  { code: "30200", name: "대전광역시 유성구", sido: "대전광역시", sigungu: "유성구" },
  { code: "30230", name: "대전광역시 대덕구", sido: "대전광역시", sigungu: "대덕구" },
  { code: "31110", name: "울산광역시 중구", sido: "울산광역시", sigungu: "중구" },
  { code: "31140", name: "울산광역시 남구", sido: "울산광역시", sigungu: "남구" },
  { code: "31170", name: "울산광역시 동구", sido: "울산광역시", sigungu: "동구" },
  { code: "31200", name: "울산광역시 북구", sido: "울산광역시", sigungu: "북구" },
  { code: "31710", name: "울산광역시 울주군", sido: "울산광역시", sigungu: "울주군" },
  { code: "36110", name: "세종특별자치시", sido: "세종특별자치시", sigungu: "세종특별자치시" },
  { code: "41111", name: "경기도 수원시 장안구", sido: "경기도", sigungu: "수원시 장안구" },
  { code: "41113", name: "경기도 수원시 권선구", sido: "경기도", sigungu: "수원시 권선구" },
  { code: "41115", name: "경기도 수원시 팔달구", sido: "경기도", sigungu: "수원시 팔달구" },
  { code: "41117", name: "경기도 수원시 영통구", sido: "경기도", sigungu: "수원시 영통구" },
  { code: "41131", name: "경기도 성남시 수정구", sido: "경기도", sigungu: "성남시 수정구" },
  { code: "41133", name: "경기도 성남시 중원구", sido: "경기도", sigungu: "성남시 중원구" },
  { code: "41135", name: "경기도 성남시 분당구", sido: "경기도", sigungu: "성남시 분당구" },
  { code: "41150", name: "경기도 의정부시", sido: "경기도", sigungu: "의정부시" },
  { code: "41171", name: "경기도 안양시 만안구", sido: "경기도", sigungu: "안양시 만안구" },
  { code: "41173", name: "경기도 안양시 동안구", sido: "경기도", sigungu: "안양시 동안구" },
  { code: "41192", name: "경기도 부천시 원미구 ", sido: "경기도", sigungu: "부천시 원미구 " },
  { code: "41194", name: "경기도 부천시 소사구 ", sido: "경기도", sigungu: "부천시 소사구 " },
  { code: "41196", name: "경기도 부천시 오정구 ", sido: "경기도", sigungu: "부천시 오정구 " },
  { code: "41210", name: "경기도 광명시", sido: "경기도", sigungu: "광명시" },
  { code: "41220", name: "경기도 평택시", sido: "경기도", sigungu: "평택시" },
  { code: "41250", name: "경기도 동두천시", sido: "경기도", sigungu: "동두천시" },
  { code: "41271", name: "경기도 안산시 상록구", sido: "경기도", sigungu: "안산시 상록구" },
  { code: "41273", name: "경기도 안산시 단원구", sido: "경기도", sigungu: "안산시 단원구" },
  { code: "41281", name: "경기도 고양시 덕양구", sido: "경기도", sigungu: "고양시 덕양구" },
  { code: "41285", name: "경기도 고양시 일산동구", sido: "경기도", sigungu: "고양시 일산동구" },
  { code: "41287", name: "경기도 고양시 일산서구", sido: "경기도", sigungu: "고양시 일산서구" },
  { code: "41290", name: "경기도 과천시", sido: "경기도", sigungu: "과천시" },
  { code: "41310", name: "경기도 구리시", sido: "경기도", sigungu: "구리시" },
  { code: "41360", name: "경기도 남양주시", sido: "경기도", sigungu: "남양주시" },
  { code: "41370", name: "경기도 오산시", sido: "경기도", sigungu: "오산시" },
  { code: "41390", name: "경기도 시흥시", sido: "경기도", sigungu: "시흥시" },
  { code: "41410", name: "경기도 군포시", sido: "경기도", sigungu: "군포시" },
  { code: "41430", name: "경기도 의왕시", sido: "경기도", sigungu: "의왕시" },
  { code: "41450", name: "경기도 하남시", sido: "경기도", sigungu: "하남시" },
  { code: "41461", name: "경기도 용인시 처인구", sido: "경기도", sigungu: "용인시 처인구" },
  { code: "41463", name: "경기도 용인시 기흥구", sido: "경기도", sigungu: "용인시 기흥구" },
  { code: "41465", name: "경기도 용인시 수지구", sido: "경기도", sigungu: "용인시 수지구" },
  { code: "41480", name: "경기도 파주시", sido: "경기도", sigungu: "파주시" },
  { code: "41500", name: "경기도 이천시", sido: "경기도", sigungu: "이천시" },
  { code: "41550", name: "경기도 안성시", sido: "경기도", sigungu: "안성시" },
  { code: "41570", name: "경기도 김포시", sido: "경기도", sigungu: "김포시" },
  { code: "41591", name: "경기도 화성시 만세구", sido: "경기도", sigungu: "화성시 만세구" },
  { code: "41593", name: "경기도 화성시 효행구", sido: "경기도", sigungu: "화성시 효행구" },
  { code: "41595", name: "경기도 화성시 병점구", sido: "경기도", sigungu: "화성시 병점구" },
  { code: "41597", name: "경기도 화성시 동탄구", sido: "경기도", sigungu: "화성시 동탄구" },
  { code: "41610", name: "경기도 광주시", sido: "경기도", sigungu: "광주시" },
  { code: "41630", name: "경기도 양주시", sido: "경기도", sigungu: "양주시" },
  { code: "41650", name: "경기도 포천시", sido: "경기도", sigungu: "포천시" },
  { code: "41670", name: "경기도 여주시", sido: "경기도", sigungu: "여주시" },
  { code: "41800", name: "경기도 연천군", sido: "경기도", sigungu: "연천군" },
  { code: "41820", name: "경기도 가평군", sido: "경기도", sigungu: "가평군" },
  { code: "41830", name: "경기도 양평군", sido: "경기도", sigungu: "양평군" },
  { code: "43111", name: "충청북도 청주시 상당구", sido: "충청북도", sigungu: "청주시 상당구" },
  { code: "43112", name: "충청북도 청주시 서원구", sido: "충청북도", sigungu: "청주시 서원구" },
  { code: "43113", name: "충청북도 청주시 흥덕구", sido: "충청북도", sigungu: "청주시 흥덕구" },
  { code: "43114", name: "충청북도 청주시 청원구", sido: "충청북도", sigungu: "청주시 청원구" },
  { code: "43130", name: "충청북도 충주시", sido: "충청북도", sigungu: "충주시" },
  { code: "43150", name: "충청북도 제천시", sido: "충청북도", sigungu: "제천시" },
  { code: "43720", name: "충청북도 보은군", sido: "충청북도", sigungu: "보은군" },
  { code: "43730", name: "충청북도 옥천군", sido: "충청북도", sigungu: "옥천군" },
  { code: "43740", name: "충청북도 영동군", sido: "충청북도", sigungu: "영동군" },
  { code: "43745", name: "충청북도 증평군", sido: "충청북도", sigungu: "증평군" },
  { code: "43750", name: "충청북도 진천군", sido: "충청북도", sigungu: "진천군" },
  { code: "43760", name: "충청북도 괴산군", sido: "충청북도", sigungu: "괴산군" },
  { code: "43770", name: "충청북도 음성군", sido: "충청북도", sigungu: "음성군" },
  { code: "43800", name: "충청북도 단양군", sido: "충청북도", sigungu: "단양군" },
  { code: "44131", name: "충청남도 천안시 동남구", sido: "충청남도", sigungu: "천안시 동남구" },
  { code: "44133", name: "충청남도 천안시 서북구", sido: "충청남도", sigungu: "천안시 서북구" },
  { code: "44150", name: "충청남도 공주시", sido: "충청남도", sigungu: "공주시" },
  { code: "44180", name: "충청남도 보령시", sido: "충청남도", sigungu: "보령시" },
  { code: "44200", name: "충청남도 아산시", sido: "충청남도", sigungu: "아산시" },
  { code: "44210", name: "충청남도 서산시", sido: "충청남도", sigungu: "서산시" },
  { code: "44230", name: "충청남도 논산시", sido: "충청남도", sigungu: "논산시" },
  { code: "44250", name: "충청남도 계룡시", sido: "충청남도", sigungu: "계룡시" },
  { code: "44270", name: "충청남도 당진시", sido: "충청남도", sigungu: "당진시" },
  { code: "44710", name: "충청남도 금산군", sido: "충청남도", sigungu: "금산군" },
  { code: "44760", name: "충청남도 부여군", sido: "충청남도", sigungu: "부여군" },
  { code: "44770", name: "충청남도 서천군", sido: "충청남도", sigungu: "서천군" },
  { code: "44790", name: "충청남도 청양군", sido: "충청남도", sigungu: "청양군" },
  { code: "44800", name: "충청남도 홍성군", sido: "충청남도", sigungu: "홍성군" },
  { code: "44810", name: "충청남도 예산군", sido: "충청남도", sigungu: "예산군" },
  { code: "44825", name: "충청남도 태안군", sido: "충청남도", sigungu: "태안군" },
  { code: "47111", name: "경상북도 포항시 남구", sido: "경상북도", sigungu: "포항시 남구" },
  { code: "47113", name: "경상북도 포항시 북구", sido: "경상북도", sigungu: "포항시 북구" },
  { code: "47130", name: "경상북도 경주시", sido: "경상북도", sigungu: "경주시" },
  { code: "47150", name: "경상북도 김천시", sido: "경상북도", sigungu: "김천시" },
  { code: "47170", name: "경상북도 안동시", sido: "경상북도", sigungu: "안동시" },
  { code: "47190", name: "경상북도 구미시", sido: "경상북도", sigungu: "구미시" },
  { code: "47210", name: "경상북도 영주시", sido: "경상북도", sigungu: "영주시" },
  { code: "47230", name: "경상북도 영천시", sido: "경상북도", sigungu: "영천시" },
  { code: "47250", name: "경상북도 상주시", sido: "경상북도", sigungu: "상주시" },
  { code: "47280", name: "경상북도 문경시", sido: "경상북도", sigungu: "문경시" },
  { code: "47290", name: "경상북도 경산시", sido: "경상북도", sigungu: "경산시" },
  { code: "47730", name: "경상북도 의성군", sido: "경상북도", sigungu: "의성군" },
  { code: "47750", name: "경상북도 청송군", sido: "경상북도", sigungu: "청송군" },
  { code: "47760", name: "경상북도 영양군", sido: "경상북도", sigungu: "영양군" },
  { code: "47770", name: "경상북도 영덕군", sido: "경상북도", sigungu: "영덕군" },
  { code: "47820", name: "경상북도 청도군", sido: "경상북도", sigungu: "청도군" },
  { code: "47830", name: "경상북도 고령군", sido: "경상북도", sigungu: "고령군" },
  { code: "47840", name: "경상북도 성주군", sido: "경상북도", sigungu: "성주군" },
  { code: "47850", name: "경상북도 칠곡군", sido: "경상북도", sigungu: "칠곡군" },
  { code: "47900", name: "경상북도 예천군", sido: "경상북도", sigungu: "예천군" },
  { code: "47920", name: "경상북도 봉화군", sido: "경상북도", sigungu: "봉화군" },
  { code: "47930", name: "경상북도 울진군", sido: "경상북도", sigungu: "울진군" },
  { code: "47940", name: "경상북도 울릉군", sido: "경상북도", sigungu: "울릉군" },
  { code: "48121", name: "경상남도 창원시 의창구", sido: "경상남도", sigungu: "창원시 의창구" },
  { code: "48123", name: "경상남도 창원시 성산구", sido: "경상남도", sigungu: "창원시 성산구" },
  { code: "48125", name: "경상남도 창원시 마산합포구", sido: "경상남도", sigungu: "창원시 마산합포구" },
  { code: "48127", name: "경상남도 창원시 마산회원구", sido: "경상남도", sigungu: "창원시 마산회원구" },
  { code: "48129", name: "경상남도 창원시 진해구", sido: "경상남도", sigungu: "창원시 진해구" },
  { code: "48170", name: "경상남도 진주시", sido: "경상남도", sigungu: "진주시" },
  { code: "48220", name: "경상남도 통영시", sido: "경상남도", sigungu: "통영시" },
  { code: "48240", name: "경상남도 사천시", sido: "경상남도", sigungu: "사천시" },
  { code: "48250", name: "경상남도 김해시", sido: "경상남도", sigungu: "김해시" },
  { code: "48270", name: "경상남도 밀양시", sido: "경상남도", sigungu: "밀양시" },
  { code: "48310", name: "경상남도 거제시", sido: "경상남도", sigungu: "거제시" },
  { code: "48330", name: "경상남도 양산시", sido: "경상남도", sigungu: "양산시" },
  { code: "48720", name: "경상남도 의령군", sido: "경상남도", sigungu: "의령군" },
  { code: "48730", name: "경상남도 함안군", sido: "경상남도", sigungu: "함안군" },
  { code: "48740", name: "경상남도 창녕군", sido: "경상남도", sigungu: "창녕군" },
  { code: "48820", name: "경상남도 고성군", sido: "경상남도", sigungu: "고성군" },
  { code: "48840", name: "경상남도 남해군", sido: "경상남도", sigungu: "남해군" },
  { code: "48850", name: "경상남도 하동군", sido: "경상남도", sigungu: "하동군" },
  { code: "48860", name: "경상남도 산청군", sido: "경상남도", sigungu: "산청군" },
  { code: "48870", name: "경상남도 함양군", sido: "경상남도", sigungu: "함양군" },
  { code: "48880", name: "경상남도 거창군", sido: "경상남도", sigungu: "거창군" },
  { code: "48890", name: "경상남도 합천군", sido: "경상남도", sigungu: "합천군" },
  { code: "50110", name: "제주특별자치도 제주시", sido: "제주특별자치도", sigungu: "제주시" },
  { code: "50130", name: "제주특별자치도 서귀포시", sido: "제주특별자치도", sigungu: "서귀포시" },
  { code: "51110", name: "강원특별자치도 춘천시", sido: "강원특별자치도", sigungu: "춘천시" },
  { code: "51130", name: "강원특별자치도 원주시", sido: "강원특별자치도", sigungu: "원주시" },
  { code: "51150", name: "강원특별자치도 강릉시", sido: "강원특별자치도", sigungu: "강릉시" },
  { code: "51170", name: "강원특별자치도 동해시", sido: "강원특별자치도", sigungu: "동해시" },
  { code: "51190", name: "강원특별자치도 태백시", sido: "강원특별자치도", sigungu: "태백시" },
  { code: "51210", name: "강원특별자치도 속초시", sido: "강원특별자치도", sigungu: "속초시" },
  { code: "51230", name: "강원특별자치도 삼척시", sido: "강원특별자치도", sigungu: "삼척시" },
  { code: "51720", name: "강원특별자치도 홍천군", sido: "강원특별자치도", sigungu: "홍천군" },
  { code: "51730", name: "강원특별자치도 횡성군", sido: "강원특별자치도", sigungu: "횡성군" },
  { code: "51750", name: "강원특별자치도 영월군", sido: "강원특별자치도", sigungu: "영월군" },
  { code: "51760", name: "강원특별자치도 평창군", sido: "강원특별자치도", sigungu: "평창군" },
  { code: "51770", name: "강원특별자치도 정선군", sido: "강원특별자치도", sigungu: "정선군" },
  { code: "51780", name: "강원특별자치도 철원군", sido: "강원특별자치도", sigungu: "철원군" },
  { code: "51790", name: "강원특별자치도 화천군", sido: "강원특별자치도", sigungu: "화천군" },
  { code: "51800", name: "강원특별자치도 양구군", sido: "강원특별자치도", sigungu: "양구군" },
  { code: "51810", name: "강원특별자치도 인제군", sido: "강원특별자치도", sigungu: "인제군" },
  { code: "51820", name: "강원특별자치도 고성군", sido: "강원특별자치도", sigungu: "고성군" },
  { code: "51830", name: "강원특별자치도 양양군", sido: "강원특별자치도", sigungu: "양양군" },
  { code: "52111", name: "전북특별자치도 전주시 완산구", sido: "전북특별자치도", sigungu: "전주시 완산구" },
  { code: "52113", name: "전북특별자치도 전주시 덕진구", sido: "전북특별자치도", sigungu: "전주시 덕진구" },
  { code: "52130", name: "전북특별자치도 군산시", sido: "전북특별자치도", sigungu: "군산시" },
  { code: "52140", name: "전북특별자치도 익산시", sido: "전북특별자치도", sigungu: "익산시" },
  { code: "52180", name: "전북특별자치도 정읍시", sido: "전북특별자치도", sigungu: "정읍시" },
  { code: "52190", name: "전북특별자치도 남원시", sido: "전북특별자치도", sigungu: "남원시" },
  { code: "52210", name: "전북특별자치도 김제시", sido: "전북특별자치도", sigungu: "김제시" },
  { code: "52710", name: "전북특별자치도 완주군", sido: "전북특별자치도", sigungu: "완주군" },
  { code: "52720", name: "전북특별자치도 진안군", sido: "전북특별자치도", sigungu: "진안군" },
  { code: "52730", name: "전북특별자치도 무주군", sido: "전북특별자치도", sigungu: "무주군" },
  { code: "52740", name: "전북특별자치도 장수군", sido: "전북특별자치도", sigungu: "장수군" },
  { code: "52750", name: "전북특별자치도 임실군", sido: "전북특별자치도", sigungu: "임실군" },
  { code: "52770", name: "전북특별자치도 순창군", sido: "전북특별자치도", sigungu: "순창군" },
  { code: "52790", name: "전북특별자치도 고창군", sido: "전북특별자치도", sigungu: "고창군" },
  { code: "52800", name: "전북특별자치도 부안군", sido: "전북특별자치도", sigungu: "부안군" },
];

// "전국 전체" 센티넬 코드 — 전 지역 활동(배송) 대상. 자동배정 매칭 시 무조건 통과.
export const SIGUNGU_NATIONWIDE = "00000";

// 맨 앞에 "전국 전체", 이어서 시·도별 "전체" 옵션을 각 시·도 블록 앞에 끼운 최종 목록.
// code = "00000"(전국) 또는 시도 2자리 + "000"(시도 전역). 실제 시군구에 없는 센티넬.
// 자동배정 매칭: code=="00000"이면 전 지역, 끝 3자리가 "000"이면 그 시·도 전역(현장 시군구 앞 2자리 비교).
export const SIGUNGU_LIST: SigunguOption[] = (() => {
  const out: SigunguOption[] = [
    { code: SIGUNGU_NATIONWIDE, name: "전국 전체", sido: "전국", sigungu: "전체" },
  ];
  const seen = new Set<string>();
  for (const s of SIGUNGU_BASE) {
    if (!seen.has(s.sido)) {
      seen.add(s.sido);
      out.push({ code: `${s.code.slice(0, 2)}000`, name: `${s.sido} 전체`, sido: s.sido, sigungu: "전체" });
    }
    out.push(s);
  }
  return out;
})();
